module.exports = __webpack_public_path__ + "static/img/black.84957126.png";